import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputValidationModel } from '../../../../Common/Forms/models/input-validation.model';
import { validateEmail, extractEmails } from '../../../Misc/helpers/formatting/email.helper';

// Works like text-input-chips but has extended support for pasting various email strings such as
// email, email [...]
// Name <email>; Name <email>; [...]
// this barely deserves to be its own component, but does make it so you don't have to look up our email validator functions
// you might also want to look at the EMAIL mode of the handles-chips.component.ts
/**
 * ### Accessibility Usage
 * + ***ariaDescribedBy*** - use this if the email field has an external error message. Use message's id
 * + ***ariaInvalid*** - use this to indicate state if the email field can fail in certain scenario
 * + ***id*** - provide an unique id so that this component can be correctly recognized by screen readers. Use interpolation [id]="'unique_id'"
 */
@Component({
    selector: 'agpr-email-chips',
    templateUrl: './email-chips.component.html',
    styleUrls: ['../Chips/chips.component.scss'],
    standalone: false
})
export class EmailChipsComponent implements OnInit {
    readonly chipValidations = [
        new InputValidationModel({
            isValid: validateEmail,
            errorKey: 'invalidEmailFormat' // localization key
        })
    ];
    readonly splitOnPattern = extractEmails;

    @Input() disabled: boolean = false;
    @Input() placeholder: string = '';
    @Input() errorKey: string;
    @Input() clearAllChipsTooltip: string;
    @Input() showDuplicateErrorKey: string = null;
    @Input() header: string;
    @Input() tooltip: string;
    @Input() ariaLabel: string = '';
    @Input() ariaDescribedBy: string = '';
    @Input() ariaInvalid: boolean;
    @Input() id: string;

    @Input() value: string[] = [];
    @Output() valueChange: EventEmitter<string[]> = new EventEmitter();

    ngOnInit(): void {
        if (this.errorKey) {
            this.chipValidations[0].errorKey = this.errorKey;
        }
    }
}
